export default "__VITE_ASSET__BwbWMhvD__"